(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["void-delivery-summary"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){const link=event.target.closest('[data-void-delivery-target]');if(!link)return;const details=document.getElementById(link.dataset.voidDeliveryTarget);if(!details)return;event.preventDefault();details.open=true;details.scrollIntoView({block:'center',behavior:'auto'});const summary=details.querySelector('summary');if(summary)summary.focus({preventScroll:true});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["void-help-panel"] && !Shopify.designMode) return;
  try {
    (function(){
 function bindHelp(){
  const wrapper=document.querySelector('[data-void-help]');
  if(!wrapper||wrapper.dataset.bound)return;
  wrapper.dataset.bound='true';
  const dialog=wrapper.querySelector('dialog');
  const launch=wrapper.querySelector('.void-help__launch');
  function openHelp(){if(!dialog.open)dialog.showModal();}
  launch.addEventListener('click',openHelp);
  wrapper.querySelector('[data-help-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();}});
  dialog.addEventListener('close',()=>launch.focus());
  document.addEventListener('click',event=>{if(event.target.closest('[data-open-void-help]'))openHelp();});
  if(wrapper.querySelector('[data-help-result]')){wrapper.querySelector('.void-help__write').open=true;openHelp();}
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bindHelp);else bindHelp();
 document.addEventListener('shopify:section:load',bindHelp);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["void-mobile-purchase"] && !Shopify.designMode) return;
  try {
    function voidBindPurchaseShortcuts(){document.querySelectorAll('[data-void-purchase-section]').forEach(bar=>{if(bar.dataset.bound)return;const root=document.getElementById('MainProduct-'+bar.dataset.voidPurchaseSection);const buy=root?.querySelector('button[name="add"]');if(!root||!buy)return;bar.dataset.bound='true';new IntersectionObserver(entries=>{bar.hidden=entries[0].isIntersecting||entries[0].boundingClientRect.top>=0;}).observe(buy);bar.querySelector('button').addEventListener('click',()=>{const target=root.querySelector('variant-selects')||buy;target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});(target.querySelector('input,select,button')||buy).focus({preventScroll:true});});});}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',voidBindPurchaseShortcuts);}else{voidBindPurchaseShortcuts();}document.addEventListener('shopify:section:load',voidBindPurchaseShortcuts);
  } catch(e) { console.error(e); }
})();

})();
